<template>
<div class="moveDialog">
  <div style="margin-bottom: 20px;text-align: right;">
    <el-button type="primary" style="margin-right: 16px" @click="getallparams()" >读取参数</el-button>
    <el-button type="primary"  @click="getnewparam()" >下发获取指令</el-button>

  </div>

  <div class="sp-item" >

    <p style="margin-bottom: 10px;">设备地址配置：<span @click="changeopen" style="cursor:pointer;"> 展开 <img :class="isopen?'rotejiao':''" src="../../../../assets/home/icon_right.png" alt=""></span>
      <span style="float: right;margin-right: 20px;">
        <el-checkbox v-model="isdesin">是否修改地址</el-checkbox>
      </span>
    </p>
    <el-table
                v-show="isopen"
                :cell-style="rowClass"
                :header-cell-style="headClass"
                ref="multipleTable"
                v-loading="isload"
                :data="topdata"
                row-key="label"
                empty-text="暂无数据"
                tooltip-effect="dark"
                style="width:100%;"

              >

                <el-table-column
                  prop="label"
                  label='参数名称'
                >

                </el-table-column>
                <el-table-column
                  prop="value"
                  label='参数值'
                >
                  <template slot-scope="scope">

                    <el-input
                      v-if="scope.row.dataType!='date'"
                      :disabled="!isdesin"
                      style="width: 220px;"
                      v-model="scope.row.value">
                    </el-input>
                    <el-date-picker
                      v-if="scope.row.dataType=='date'"
                      v-model="scope.row.value"
                      type="datetime"
                      value-format="timestamp"
                    ></el-date-picker>
                  </template>
                </el-table-column>


              </el-table>
    <p class="center-p">设备门限配置：</p>
    <el-table
      v-loading="isload"
      :cell-style="rowClass"
      :header-cell-style="headClass"
      ref="multipleTable"

      :data="bomdata"
      row-key="label"
      empty-text="暂无数据"
      tooltip-effect="dark"
      style="width:100%;"

    >

      <el-table-column
        prop="label"
        label='参数名称'
      >

      </el-table-column>
      <el-table-column
        prop="value"
        label='参数值'
      >
        <template slot-scope="scope">

          <el-input
            v-if="scope.row.dataType!='date'"
            style="width: 220px;"
            v-model="scope.row.value">
          </el-input>
          <el-date-picker
            v-if="scope.row.dataType=='date'"
            v-model="scope.row.value"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
        </template>
      </el-table-column>


    </el-table>
  </div>
  <div style="text-align:right;margin-top:20px;" >
    <el-button type="primary" @click="uploadParams()" > 确认 </el-button>
    <el-button @click="cancelChange()">取消</el-button>
  </div>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
export default {
  name: "moveDialog",
  props: {

  },
  data() {
    return {
      topdata:[],
      bomdata:[],
      isopen:false,
      isdesin:false,
      isload:false,
      paramname:"",
      timer: "",
      allparam:[],
      nowterminalId:"",
    };
  },
  mounted() {
    let that=this

    Bus.$on("changeterminalId", (val) => {
      that.isdesin=false
      that.isopen=false
      that.nowterminalId=val
      that.deounce( that.getallparams() , 500)

    });

  },
  methods: {
    getnewparam(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/msg/sendParamRemote";

      param.data=
        {
          terminalId: this.nowterminalId,
        }
      Axios.ajax(param).then((res)=>{
        this.parameter=[]
        if(res.resultCode=='0'){
          that.isload=true
          setTimeout(function(){
            that.isload=false
            that.getallparams()
          }, 30000);
        }else{

          this.$message({
            type: 'error',
            message:res.resultMessage
          });
        }

        // this.alljsondata={}
        // this.parameter=[]
        //
        // param.method="post";
        // param.url="/device/msg/query/parameterDB";
        //
        // param.data=
        //   {
        //     terminalId: this.nowequmentdata.terminalId,
        //   }
        // Axios.ajax(param).then((res)=>{
        //   this.parameter=[]
        //   if(res.resultCode=='0'){
        //
        //     if(res.data){
        //       let messsdata=JSON.parse(res.data)
        //
        //       this.alljsondata={
        //         num:messsdata.num,
        //         startAddress:messsdata.startAddress,
        //         values:[]
        //       }
        //       for(let key in messsdata.values){
        //         this.parameter.push({
        //           label:messsdata.values[key].description,
        //           dataType:messsdata.values[key].dataType,
        //           value:messsdata.values[key].value,
        //           keyword:messsdata.values[key].parameterName,
        //         })
        //         this.alljsondata.values.push(messsdata.values[key])
        //
        //       }
        //     }else{
        //
        //       this.$message({
        //         type: 'error',
        //         message:"当前设备无数据"
        //       });
        //     }
        //
        //
        //   }else{
        //
        //     this.$message({
        //       type: 'error',
        //       message:res.resultMessage
        //     });
        //   }
        //
      })

    },
    cancelChange(){
      this.isdesin=false
      this.isopen=false
      Bus.$emit('colseupload',"1")
    },
    //修改参数
    uploadParams(data) {



      let that = this;
      let param = {};


      param.method = "post";

      param.url = "/device/msg/setParameter";
      param.data = {
        "YHSWCGDAllParam":
          {},
        "YHSWB1AllParam":
          {},
        "YHSWA2AllParam":
          {},
        "YHSWA6AllParam":
          {},
        "NJ2DC63AllParam":
          {},
        "TUYAA10AllParam":
          {},

      };

        if(this.isdesin){
          for (let i = 0; i < this.topdata.length; i++) {
            param.data[this.paramname][this.topdata[i].key]=this.topdata[i].value
          }
          for (let i = 0; i < this.bomdata.length; i++) {
            param.data[this.paramname][this.bomdata[i].key]=this.bomdata[i].value
          }
        }else{
          for (let i = 0; i < this.bomdata.length; i++) {
            param.data[this.paramname][this.bomdata[i].key]=this.bomdata[i].value
          }
        }
      param.data.setAddress=this.isdesin
      param.data.terminalId=this.nowterminalId

      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message:"提交成功"
          });
          that.isload=true
          setTimeout(function(){
            that.isload=false
            that.getallparams()
          }, 30000);
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    // 表头样式设置
    headClass () {
      return 'text-align: center;background:rgb(242,242,242);color:rgb(140,138,140)'
    },
    // 表格样式设置
    rowClass () {
      return 'text-align: center;'
    },
    changeopen(){
      this.isopen=!this.isopen
    },
    deounce(fn,wait){
      let timer=null
      return function(){
        if(timer!==null){
          clearTimeout(timer)
        }
        timer=setTimeout(fn,wait)
      }
    },
    getallparams(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/device/msg/queryDB";
      param.data={
        "terminalId":this.nowterminalId,
      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){

          this.paramname=''
        this.allparam=[]
        this.topdata=[]
        this.bomdata=[]
          switch(res.data.type){
            case "YHSW-CGD":
              this.paramname = "YHSWCGDAllParam";
              break;
            case "YHSW-B1":
              this.paramname = "YHSWB1AllParam";
              break;
            case "YHSW-A2":
              this.paramname = "YHSWA2AllParam";
              break;
            case "YHSW-A6":
              this.paramname = "YHSWA6AllParam";
              break;
            case "NJ2D-C63":
              this.paramname = "NJ2DC63AllParam";
              break;
            case "TUYA-A10":
              this.paramname ="TUYAA10AllParam";
              break;
            default:
              this.paramname=''
          }
          for(let key in res.data[this.paramname]){
            let name=''
            let type='string'
            switch(key){
              case "MAC":
                name = "终端地址";
                break;
              case "IP":
                name = "IP地址";
                break;
              case "Port":
                name = "端口号";
                break;
              case "Port_upgrade":
                name = "升级端口号";
                break;
              case "MS":
                name = "主从机";
                break;
              case "Addr485":
                name = "通讯地址";
                break;
              case "SlaveAddr485Max":
                name = "从机通讯最大地址";
                break;
              case "Num_MS":
                name = "主从总数";
                break;
              case "U_upperBound":
                name = "过压门限";
                break;
              case "I_upperBound":
                name = "过流门限";
                break;
              case "U_lowerBound":
                name = "欠压门限";
                break;
              case "IresBound":
                name = "剩余电流门限";
                break;
              case "T_upperBound":
                name = "温度告警门限";
                break;
              case "Current_transformer_ratioA":
                name = "A相电流互感器变比";
                break;
              case "Current_transformer_ratioB":
                name = "B相电流互感器变比";
                break;
              case "Current_transformer_ratioC":
                name = "C相电流互感器变比";
                break;
              case "Current_transformer_ratioN":
                name = "N相电流互感器变比";
                break;
              case "Voltage_transformer_ratio":
                name = "电压互感器变比";
                break;
              case "EventLabel":
                name = "事件软压板";
                break;
              case "Event":
                name = "开关量软压板";
                break;
              case "PurseTime":
                name = "脉冲时间";
                break;
              case "Ifx_upperBoundA":
                name = "A相电流谐波超标门限";
                break;
              case "Ifx_upperBoundB":
                name = "B相电流谐波超标门限";
                break;
              case "Ifx_upperBoundC":
                name = "C相电流谐波超标门限";
                break;
              case "Ifx_upperBoundN":
                name = "N相电流谐波超标门限";
                break;
              case "RresBound":
                name = "绝缘阻抗突变门限";
                break;
              case "XbIncrementBound":
                name = "谐波增量门限值";
                break;
                case "AlarmSL":
                name = "声光报警软压板";
                break;
                case "I_motor_start":
                name = "电机启动电流";
                break;
              case "Time_motor_start":
                name = "电机启动时间";
                break;
              case "Label_motor":
                name = "电机启动软压板";
                break;
              case "I_upperBound1":
                name = "第一支路过流门限";
                break;
              case "I_upperBound2":
                name = "第二支路过流门限";
                break;
              case "I_res1":
                name = "第一支路剩余电流";
                break;
              case "I_res2":
                name = "第二支路剩余电流";
                break;
              case "Ifh1":
                name = "第一支路负荷电流";
                break;
              case "Ifh2":
                name = "第二支路负荷电流";
                break;
              case "Ires1":
                name = "第一支路剩余电流";
                break;
              case "Ires2":
                name = "第二支路剩余电流";
                break;
              case "XbBound1":
                name = "第一路谐波超标门限";
                break;
              case "XbBound2":
                name = "第二路谐波超标门限";
                break;
              case "RresBound1":
                name = "第一路绝缘阻抗突变门限";
                break;
              case "RresBound2":
                name = "第二路绝缘阻抗突变门限";
                break;
              case "I_upperBound3":
                name = "第三支路过流门限";
                break;
              case "I_upperBound4":
                name = "第四支路过流门限";
                break;
              case "I_upperBound5":
                name = "第五支路过流门限";
                break;
              case "I_upperBound6":
                name = "第六支路过流门限";
                break;
              case "I_res3":
                name = "第三支路剩余电流";
                break;
              case "I_res4":
                name = "第四支路剩余电流";
                break;
              case "I_res5":
                name = "第五支路剩余电流";
                break;
              case "I_res6":
                name = "第六支路剩余电流";
                break;
              case "Ifh3":
                name = "第三支路负荷电流";
                break;
                case "Ifh4":
                name = "第四支路负荷电流";
                break;
              case "Ifh5":
                name = "第五支路负荷电流";
                break;
              case "Ifh6":
                name = "第六支路负荷电流";
                break;
              case "Ires3":
                name = "第三支路剩余电流";
                break;
              case "Ires4":
                name = "第四支路剩余电流";
                break;
              case "Ires5":
                name = "第五支路剩余电流";
                break;
              case "Ires6":
                name = "第六支路剩余电流";
                break;
              case "XbBound3":
                name = "第三路谐波超标门限";
                break;
              case "XbBound4":
                name = "第四路谐波超标门限";
                break;
              case "XbBound5":
                name = "第五路谐波超标门限";
                break;
              case "XbBound6":
                name = "第六路谐波超标门限";
                break;
              case "RresBound3":
                name = "第三路绝缘阻抗突变门限";
                break;
              case "RresBound4":
                name = "第四路绝缘阻抗突变门限";
                break;
              case "RresBound5":
                name = "第五路绝缘阻抗突变门限";
                break;
              case "RresBound6":
                name = "第六路绝缘阻抗突变门限";
                break;
              case "Ires_Bound":
                name = "剩余电流门限";
                break;
              case "P_upperBound":
                name = "功率越线门限";
                break;
              case "Irex_Bound":
                name = "剩余谐波电流门限";
                break;
              case "TimerSwitch1":
                name = "定时器1开关软压板";
                break;
              case "TimerSwitch2":
                name = "定时器2开关软压板";
                break;
              case "TimerSwitch3":
                name = "定时器3开关软压板";
                break;
              case "TimerSwitch4":
                name = "定时器4开关软压板";
                break;
              case "TimerSwitch5":
                name = "定时器5开关软压板";
                break;
              case "TimerSwitch6":
                name = "定时器6开关软压板";
                break;
              case "TimerSwitch7":
                name = "定时器7开关软压板";
                break;
              case "TimerOpenTime1":
                name = "定时器1空开打开时间";
                type='date'
                break;
              case "TimerCloseTime1":
                name = "定时器1空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime2":
                name = "定时器2空开打开时间";
                type='date'
                break;
              case "TimerCloseTime2":
                name = "定时器2空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime3":
                name = "定时器3空开打开时间";
                type='date'
                break;
              case "TimerCloseTime3":
                name = "定时器3空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime4":
                name = "定时器4空开打开时间";
                type='date'
                break;
              case "TimerCloseTime4":
                name = "定时器4空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime5":
                name = "定时器5空开打开时间";
                type='date'
                break;
              case "TimerCloseTime5":
                name = "定时器5空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime6":
                name = "定时器6空开打开时间";
                type='date'
                break;
              case "TimerCloseTime6":
                name = "定时器6空开关闭时间";
                type='date'
                break;
              case "TimerOpenTime7":
                name = "定时器7空开打开时间";
                type='date'
                break;
              case "TimerCloseTime7":
                name = "定时器7空开关闭时间";
                type='date'
                break;
              case "U_sample":
                name = "电压采样修正值";
                break;
              case "Ifh_sample":
                name = "负荷电流采样修正值";
                break;
              case "Time_interval":
                name = "主动发送数据时间间隔";
                break;
              case "I_upperBound7":
                name = "第七支路过流门限";
                break;
              case "I_upperBound8":
                name = "第八支路过流门限";
                break;
              case "I_upperBound9":
                name = "第九支路过流门限";
                break;
              case "I_upperBound10":
                name = "第十支路过流门限";
                break;

              default:
                name=''
            }
            if(key=='MAC' || key=='IP' ||key=='Port' ||key=='Port_upgrade' ||key=='Addr485' ||key=='MS' ||key=='Num_MS' ||key=='SlaveAddr485Max'){
              this.topdata.push({
                label:name,
                key:key,
                value:res.data[this.paramname][key],
                dataType:type
              })
            }else{
              this.bomdata.push({
                label:name,
                key:key,
                value:res.data[this.paramname][key],
                dataType:type

              })
            }



          }
        }else{
          this.$message({
            type: 'error',
            message: res.resultMessage
          });
        }

      })
    },
    deounce(fn,wait){
      let timer=null
      return function(){
        if(timer!==null){
          clearTimeout(timer)
        }
        timer=setTimeout(fn,wait)
      }
    },
  },
  watch:{

  },
  beforeDestroy() {
    this.isopen=false
    this.isdesin=false
  },
};
</script>

<style lang="less" scoped>
.moveDialog {
  padding: 10px 20px 10px 20px;


}
.center-p{
  margin: 16px 0;
}
.rotejiao{
  transform: rotate(90deg);
}
.sp-item{
  max-height:500px;
  overflow: auto;
}
</style>
